import React, { useEffect, useState } from 'react';
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? 'bg-cream/90 backdrop-blur-md py-4 md:py-[12px] shadow-sm' : 'bg-transparent py-6 md:py-[12px]'}`} data-id="element-77">
      <div className="max-w-7xl md:max-w-[780px] mx-auto px-6 md:px-[24px] flex justify-center items-center" data-id="element-78">
        <div className="font-serif text-xl md:text-[14px] tracking-wide text-ink" data-id="element-79">
          El Cambio Hormonal
        </div>
      </div>
    </header>;
}